import { notificationQueryKeys, notificationQueryOptions } from '@/hooks/queries/notification.queries';
import { NotificationService } from '@/services/notification.service';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useNotifications(viewerId?: string | null, limit = 20, enabled = true) {
  const query = useQuery(notificationQueryOptions.list(viewerId, limit, enabled));

  return {
    notifications: query.data?.data ?? [],
    total: query.data?.meta.total ?? 0,
    unreadCount: query.data?.meta.unreadCount ?? 0,
    isError: query.isError,
    isFetching: query.isFetching,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}

export function useNotificationSummary(viewerId?: string | null, enabled = true) {
  const query = useQuery(notificationQueryOptions.summary(viewerId, enabled));

  return {
    unreadCount: query.data?.unreadCount ?? 0,
    isLoading: query.isLoading,
  };
}

export function useNotificationActions(viewerId?: string | null) {
  const queryClient = useQueryClient();
  const refreshNotifications = () => queryClient.invalidateQueries({ queryKey: notificationQueryKeys.user(viewerId) });
  const markReadMutation = useMutation({
    mutationFn: NotificationService.markRead,
    onSuccess: refreshNotifications,
  });
  const markAllReadMutation = useMutation({
    mutationFn: NotificationService.markAllRead,
    onSuccess: refreshNotifications,
  });

  return {
    markRead: markReadMutation.mutateAsync,
    markAllRead: markAllReadMutation.mutateAsync,
    isMarkingRead: markReadMutation.isPending,
    isMarkingAllRead: markAllReadMutation.isPending,
  };
}
